import React from 'react';
import { useAxiosInterceptors } from './shared/hooks/axios/useAxiosInterceptors';
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { useAppTheme } from './shared/hooks/theme/useAppTheme';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './shared/routes/routes';
import { SnackbarProvider } from 'notistack';
import { CollapsibleErrorSnackbar } from './components/snackbar/CollapsibleErrorSnackbar';
import { useKeycloakTokenRefresh } from './shared/hooks/authentication/useKeycloakTokenRefresh';
// import 'flag-icons/css/flag-icons.min.css';

const baseHref = document.querySelector('base')?.getAttribute('href')?.replace(/\/$/, '') || '/';

const App: React.FC = () => {
  useAxiosInterceptors(); // setup axios interceptors
  const theme = useAppTheme();
  useKeycloakTokenRefresh();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter basename={baseHref}>
          <SnackbarProvider
            Components={{
              collapsible: CollapsibleErrorSnackbar,
            }}
          >
            <AppRoutes />
          </SnackbarProvider>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
